import { render } from "./Chart.vue?vue&type=template&id=0b80d127&ts=true"
import script from "./Chart.vue?vue&type=script&lang=ts"
export * from "./Chart.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__